'use client';

import Image from 'next/image';
import CvButton from './CvButton';
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(userAgent);
    setIsSafari(isSafariBrowser);
  }, []);

  return (
    <section className="relative overflow-hidden pb-[40px] pt-[30px] md:px-[10px] md:py-[60px]">
      <div className="absolute inset-0 -z-10">
        <div className="relative h-full w-full">
          <Image
            src="/static/images/service-page/fv_background.webp"
            alt="背景画像"
            fill
            priority
            quality={90}
            className="object-cover"
            sizes="100vw"
            style={{
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
        </div>
      </div>

      <div className="mx-auto max-w-5xl md:px-4">
        <div className="flex flex-col items-center md:flex-row md:items-center">
          <div className="flex flex-col items-center text-center md:mb-[30px] md:w-1/2">
            <Image
              src={
                isSafari
                  ? '/static/images/service-page/catch_copy.webp'
                  : '/static/images/service-page/catch_copy.svg'
              }
              width={380}
              height={44}
              alt="エンジニア特化のAIキャリア診断"
              className="w-full max-w-[320px] md:max-w-[380px]"
            />
            {/* デスクトップの際にCVボタンを表示 */}
            <div className="mt-8 hidden md:block md:w-full">
              <CvButton />
            </div>
          </div>
          <div className="mt-4 w-full md:w-3/4">
            <div className="relative h-[316px] w-full md:aspect-[16/9] md:h-auto">
              {/* モバイル用画像 */}
              <Image
                src="/static/images/service-page/mockup_fv_sp.webp"
                alt="ASSIGN TECHのサービス画面（モバイル）"
                fill
                className="max-w-[571px] object-cover md:hidden"
                priority
                sizes="(max-width: 768px) 100vw"
                style={{
                  objectPosition: 'left 0',
                  transform: 'translateX(5%)'
                }}
              />
              {/* デスクトップ用画像 */}
              <Image
                src="/static/images/service-page/mockup_fv_pc.webp"
                alt="ASSIGN TECHのサービス画面（デスクトップ）"
                fill
                className="hidden object-contain md:block"
                priority
                sizes="(min-width: 1024px) 50vw, 33vw"
              />
            </div>
          </div>
          {/* モバイルの際にCVボタンを表示 */}
          <div className="mt-4 flex w-full justify-center md:hidden">
            <div className="w-full text-center">
              <CvButton />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
